/* eslint-disable @typescript-eslint/no-explicit-any */
import firebase from './index'

firebase.analytics()

const logAnalyticsEvent = (
  eventName: string,
  eventParams?: { [key: string]: any },
): void => {
  return firebase.analytics().logEvent(eventName, eventParams)
}
export default logAnalyticsEvent
